export const INTERNAL_SERVER_ERROR = 500
export const NOT_IMPLEMENT = 501
export const BAD_GATEWAY = 502
export const SERVICE_UNAVAILABLE = 503
export const GATEWAY_TIMEOUT = 504
export const UNAUTHORIZED = 401
export const NOT_FOUND = 404
export const UNPROCESSABLE_ENTITY = 422
export const NETWORK_IS_OFFLINE = 0